import { useEffect } from 'react';
import UrlParse from 'url-parse';

/** Забирает значение инпута из квери параметра при инициализации на клиенте */
export function useValueFromQuery(
    queryName = '',
    name = '',
    handleChange: (a: { name?: string; value: string }) => void
) {
    useEffect(() => {
        if (queryName) {
            const { query } = new UrlParse(window.location.toString(), {}, true);
            const phoneValue = `+${decodeURIComponent(query[queryName] ?? '')
                .slice(1)
                .replace(/\+/g, ' ')}`;
            if (/^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(phoneValue)) {
                handleChange({ name, value: phoneValue });
            }
        }
    }, []);
}
